import { useContext } from "react";
import { Spin } from "antd";
import { SubscriptionContext } from "context/SubscriptionProvider";
import NotFoundPage from "pages/not-found";
import { ErrorMessages } from "constants/index";
import AuditReportsTab from "./audit-reports/audit-reports-tab";

function SubscriptionReportsMenu() {
  const { isFeatureFlagEnabled, isProductEntitlementsDataAvailable } =
    useContext(SubscriptionContext);

  const isSubscriptionActivityLogEnabled = isFeatureFlagEnabled(
    "SUBSCRIPTION_ACTIVITY_LOG"
  );

  if (!isProductEntitlementsDataAvailable) {
    return (
      <div className="w-full h-full bg-ciq-gray-50 flex justify-center items-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!isSubscriptionActivityLogEnabled) {
    return (
      <NotFoundPage
        status="403"
        title="403"
        subTitle={ErrorMessages.UnauthorizedPageAccess}
      />
    );
  }

  return (
    <div className="flex flex-col h-full w-full" data-testid="reports-page">
      <div
        className="w-full px-8 py-4 font-semibold text-xl"
        data-testid="reports-page-title"
      >
        Reports
      </div>
      <div className="h-full overflow-auto bg-ciq-gray-50">
        <AuditReportsTab />
      </div>
    </div>
  );
}

export default SubscriptionReportsMenu;
